module.exports = __webpack_public_path__ + "static/media/checked.8c15b7a7.png";